import { Controller } from "stimulus";

export default class extends Controller {
  open() {
    document.body.classList.add("modal-open");
    this.element.setAttribute("style", "display: block;");
    this.element.classList.add("show");
    this.createBackdrop();
  }

  close() {
    document.body.classList.remove("modal-open");
    this.element.removeAttribute("style");
    this.element.classList.remove("show");
    this.removeBackdrop();
  }

  createBackdrop() {
    const backdrop = document.createElement("div");
    backdrop.classList.add("modal-backdrop");
    backdrop.style.opacity = 0.5;
    this.element.parentElement.id = "for_modal";
    document.getElementById("for_modal").appendChild(backdrop);
  }

  removeBackdrop() {
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
  }
}